import { render, staticRenderFns } from "./Modifier_report.vue?vue&type=template&id=6e23e082&scoped=true&"
import script from "./Modifier_report.vue?vue&type=script&lang=js&"
export * from "./Modifier_report.vue?vue&type=script&lang=js&"
import style0 from "./Modifier_report.vue?vue&type=style&index=0&id=6e23e082&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e23e082",
  null
  
)

export default component.exports